export enum EICONS
{
    HOME        		= 'InfoOutlined',
    PROGRAMAS   		= 'LiveTvIcon',
    SERIES      		= 'CastConnectedIcon',
    OPCOES      		= 'VideoSettingsIcon',
    PRODUTORAS  		= 'CameraIndoorIcon',
    CONFIGURACAOES 	    = 'SettingsIcon',
    GENERO      		= 'LocalOfferIcon',
    IDIOMAS     		= 'LanguageIcon',
    LIST		        = 'ListAltIcon',
    LIST_ADD    		= 'PlaylistAddIcon',
    USUARIOS    		= 'ManageAccountsIcon'
}